import axios from 'axios';
import { CustomGroup, CustomGroupRequest } from './models/CustomGroup';
import { FetchDataRequest, FetchDataResult } from "../../../Common/models/grid";
import { SieveResponse } from "../../../Common/models/sieve";
import {
  getSieveRequestModel,
  mapToFetchDataResult,
} from "../../../Common/utils/sieveRequestModel";
import { User } from '../../../Common/models/FormModels';


export const getCustomGroups = async (projectId: string, toolId: string): Promise<CustomGroup[]> => {
  const { data } = await axios.get<CustomGroup[]>(
    `${window.configuration.apiUrl}api/CustomGroups/${projectId}/${toolId}`
  );

  return data;
};

export const createCustomGroup = async (request: CustomGroupRequest): Promise<void> => {
  await axios.post(
    `${window.configuration.apiUrl}api/CustomGroups`,
    request,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const deleteCustomGroup = async (request: CustomGroupRequest): Promise<void> => {
  await axios.delete(
    `${window.configuration.apiUrl}api/CustomGroups`,
    {
      data: request,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const getCustomGroupUsers = async (
  projectId: string,
  toolId: string,
  groupName: string,
  request: FetchDataRequest
): Promise<FetchDataResult> => {
  const sieveRequest = getSieveRequestModel(request);
  const { data: users } = await axios.get<SieveResponse>(
    `${window.configuration.apiUrl}api/CustomGroups/${projectId}/${toolId}/${groupName}/members`,
    { params: sieveRequest }
  );

  return mapToFetchDataResult(users);
};


export const validateCustomGroupExists = async (
  projectId: string,
  toolId: string,
  toolProjectId: string,
  groupName: string
): Promise<boolean> => {
  const { data } = await axios.get<boolean>(
    `${window.configuration.apiUrl}api/CustomGroups/validateCustomGroupExists`,
    {
      params: {
        ProjectId: projectId,
        ToolId: toolId,
        ToolProjectId: toolProjectId,
        GroupName: groupName,
      },
    }
  );
  
  return data;
};
export interface ManageCustomGroupMembersCommand {
  ProjectId: string;
  ToolId: string;
  ToolProjectId: string;
  GroupName: string;
  Add: User[];
  Delete: User[];
}

export const manageCustomGroupMembers = async (
  command: ManageCustomGroupMembersCommand
): Promise<void> => {
  await axios.put(
    `${window.configuration.apiUrl}api/CustomGroups/members`,
    command,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};